

<script >
import { computed, defineExpose } from 'vue-demi';
import { useRedpackData } from './api';
import FEGORender from '@futuweb/fego-render';
const {
  plugins: {
    ComplexComp
  }
} = FEGORender;
import ChildItem from '../children/item/render/index.vue';
import PacketItem from '../children/packet/render/index.vue';
import { CHILD, PACKET } from '../constant';
const __sfc_main = {
  name: 'common-redpacket',
  mixins: [ComplexComp.Inner.Parent.Mixins({
    [CHILD]: ChildItem,
    [PACKET]: PacketItem
  })]
};
__sfc_main.props = ['tpl'];
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const {
    state,
    methods
  } = useRedpackData(props.tpl.props.actSign);
  const packet = computed(() => {
    const packet = props.tpl.children[0];
    return {
      ...packet,
      props: {
        ...packet.props,
        sendRedpack: async () => methods.sendRedpack(false)
      }
    };
  });
  const _child = computed(() => {
    const macthRule = state.data?.matchRule;
    if (!macthRule) {
      return null;
    }
    const child = props.tpl.children.find(item => item.props.ruleSign === macthRule.ruleSign);
    if (!child) {
      return null;
    }
    return {
      ...child,
      props: {
        ...child.props,
        childSendRedpack: methods.$callOtherComponentSendPrize
      }
    };
  });
  return Object.assign({
    state,
    packet,
    _child
  }, {
    otherComponentCompleteSend: async () => methods.sendRedpack(true),
    backToRedpacketPage: async () => methods.setForceRedpacketPage(),
    openRedpacket: async () => methods.sendRedpack(false)
  });
};
export default __sfc_main;
</script>

<template>
    <div class="common-redpacket" v-if="state.data && !state.data.redirectUrl">
        <div v-if="!state.data.record || state.forceRedpacketPage">
            <inner-children-renderer :children="packet" />
        </div>
        <div v-show="state.data.record && !state.forceRedpacketPage" v-if="_child"
            :key="state.data.record ? 'has-record' : 'no-record'">
            <inner-children-renderer :children="_child" />
        </div>
    </div>
</template>

<style lang="less" scoped>
.common-redpacket {
    width: 100% !important;
}
</style>
